import { useState } from 'react';
import { Check, Copy } from 'lucide-react';

import styles from './EntityIdBadge.module.css';

interface EntityIdBadgeProps {
  id: string;
  label?: string;
}

function shorten(id: string): string {
  // First 8 chars of UUID, enough to be unique-looking and short.
  return id.length > 8 ? id.slice(0, 8) : id;
}

export function EntityIdBadge({ id, label = 'ID' }: EntityIdBadgeProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      window.setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch {
      // clipboard blocked — no-op, fail silently
    }
  }

  return (
    <span className={styles.wrap}>
      <span className={styles.label}>{label}</span>
      <code className={styles.id} dir="ltr" title={id}>
        {shorten(id)}
      </code>
      <button
        type="button"
        className={styles.copy}
        onClick={() => {
          void handleCopy();
        }}
        aria-label={copied ? 'הועתק' : 'העתק ID'}
        title={copied ? 'הועתק' : 'העתק ID'}
      >
        {copied ? <Check size={12} aria-hidden="true" /> : <Copy size={12} aria-hidden="true" />}
      </button>
    </span>
  );
}
